import React from 'react';
import './projects.css';
import Body from './Body';

function Projects() {
    return(
        <div>
            {/* ----- FIRST PROJECT ----- */}
            <section id='projects' className='alternate_bg'>
                <h5>My Work</h5>
                <h2>Projects</h2>
                <div className='project'>
                    <div className='project__description'>
                        <div className='project__title'>
                        <h3>FI2GO || Health & Fitness Web Application</h3>
                        </div>
                        <div className='project__details'>
                            <ul>
                                <li>Creates a workout and nutrition schedule based on your physiology and personal targets.</li>
                                <li>In the development process, I learned how to link the frontend to backend via API calls.</li>
                            </ul>
                        </div>
                        <div className='project__skills'>
                            <p className='boldText'>Tools Used: ReactJS, HTML/CSS, Java, MySQL, RESTful APIs</p>
                        </div>
                    </div>
                    <Body className="project__image"/>
                </div>

                {/* ----- SECOND PROJECT ----- */}
                <div className='project'>
                    <div className='project__description'>
                        <div className='project__title'>
                        <h3>Food Delivery System || University Group Project</h3>
                        </div>
                        <div className='project__details'>
                            <ul>
                                <li>Requirements Engineering assignment in which I led our team to achieve 83% (top mark).</li>
                                <li>My role as team leader was to allocate tasks between the Team and keep all engaged.</li>
                                <li>Helped me learn how to make the most of my resources.</li>
                            </ul>
                        </div>
                        <div className='project__skills'>
                            <p className='boldText'>Skills Used: Database Management, Entity-Relationship Diagrams, GIT version control</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Projects;